import { render, staticRenderFns } from "./RechageDetail.vue?vue&type=template&id=56403441"
import script from "./RechageDetail.vue?vue&type=script&lang=js"
export * from "./RechageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports